export default {
  path: '/businessData',
  name: 'businessData',
  component: () => import('@/layouts/BaseLayout'),
  redirect: '/businessData/client',
  children: [
    {
      path: 'client',
      meta: { title: '客户', permission: 'client' },
      component: () => import('@/views/businessData/client/index'),
    },
    {
      path: 'supplier',
      meta: { title: '供应商', permission: 'supplier' },
      component: () => import('@/views/businessData/supplier/index'),
    },
    {
      path: 'warehouse',
      meta: { title: '仓库', permission: 'warehouse' },
      component: () => import('@/views/businessData/warehouse/index'),
    },
    {
      path: 'settlement_account',
      meta: { title: '结算账户', permission: 'settlement_account' },
      component: () => import('@/views/businessData/settlementAccount/index'),
    },
    {
      path: 'revenue_expenditure_items',
      meta: { title: ' 收支项目', permission: 'revenue_expenditure_items' },
      component: () => import('@/views/businessData/revenueExpenditureItems/index'),
    },
  ],
}
